import { useQuery } from "@tanstack/react-query";
import type { ChemistrySample } from "../../../../models/lab.models";
import { getChemistrySample } from "../../repositories/ChemistriesRepository";

interface UseSampleAttributesQueryProps {
  sampleId: number | null;
}

export const useSampleAttributesQuery = ({
  sampleId,
  onError,
}: UseSampleAttributesQueryProps & { onError?: (error: Error) => void }) => {
  return useQuery<ChemistrySample | null, Error>({
    queryKey: ["lab-sample-attributes", sampleId],
    queryFn: async ({ signal }) => {
      const resp = await getChemistrySample(sampleId!, signal);
      const row = resp.data.tables[0].rows[0];
      if (!row) return null;
      return {
        SampleTypeId: row.SampleTypeId ?? null,
        SampleTypeName: row.SampleTypeName ?? "",
        Reported: row.Reported ?? null,
        SampleSequence: row.SampleSequence ?? null,
        Technician: row.Technician ?? "",
        Comments: row.Comments ?? "",
      } satisfies ChemistrySample;
    },
    enabled: sampleId != null,
    onError,
  });
};
